var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticStyle:{"max-width":"900px"}},[_c('span',{staticClass:"text-h5 d-block mb-3"},[_vm._v("Allgemeine Geschäftsbedingungen")]),_c('v-divider',{staticClass:"mb-3"}),_c('div',[_c('section',{domProps:{"innerHTML":_vm._s(_vm.logic.agb)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }